import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import upperFirst from 'lodash/upperFirst'

import { formatDateWithTime } from '@/helpers/date'
import { normalizeUserName } from '@/helpers/user'
import { normalizeCarName } from '@/helpers/car-profile'
import { routeNames } from '@/router/route-names'

import { useReviewsStore } from '@/store/reviews'

import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'

type EntitiesKeys = 'trip' | 'from' | 'to' | 'vehicle'


export default /*@__PURE__*/_defineComponent({
  __name: 'Details',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()
const reviewsStore = useReviewsStore()

const error = computed(() => reviewsStore.reviewsDetails[props.id]?.error)
const review = computed(() => reviewsStore.reviewsDetails[props.id]?.data)
const isLoading = computed(
  () => reviewsStore.reviewsDetails[props.id]?.isLoading
)

const isFromHost = computed(
  () => review.value?.user_id === review.value?.trip.host_id
)

const fromUser = computed(
  () => review.value?.trip[isFromHost.value ? 'host' : 'renter']
)
const toUser = computed(
  () => review.value?.trip[isFromHost.value ? 'renter' : 'host']
)

const entities: EntitiesKeys[] = ['trip', 'from', 'to', 'vehicle']
const tableRows = [...entities, 'score']

const routesMap: Record<EntitiesKeys, string> = {
  trip: routeNames.tripDetails,
  from: routeNames.userDetails,
  to: routeNames.userDetails,
  vehicle: routeNames.vehicleDetails,
}

const idsMap = computed<Record<EntitiesKeys, string | undefined>>(() => ({
  trip: review.value?.trip_id,
  from: fromUser.value?.id,
  to: toUser.value?.id,
  vehicle: review.value?.trip.car_profile_id,
}))

const getReviewDetails = () => {
  reviewsStore.getReviewDetails(props.id)
}

const handleShowPress = (key: EntitiesKeys) => {
  const id = idsMap.value[key]

  if (!id) return console.warn(`Can't find id for ${key} entity.`)

  router.push({ name: routesMap[key], params: { id } })
}

onMounted(() => {
  if (!isLoading.value) getReviewDetails()
})

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (error.value)
      ? (_openBlock(), _createBlock(CommonError, {
          key: 0,
          errorMessage: error.value,
          onRetryPress: getReviewDetails
        }, null, 8, ["errorMessage"]))
      : _createCommentVNode("", true),
    (!review.value)
      ? (_openBlock(), _createBlock(Loader, { key: 1 }))
      : (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 2,
          always: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_page_header, {
              onBack: _unref(router).back,
              content: `${isFromHost.value ? `Host's` : `Renter's`} review: ${_ctx.id}`
            }, null, 8, ["onBack", "content"]),
            _createVNode(_component_el_table, {
              data: tableRows,
              style: {"width":"100%"},
              "show-header": false,
              class: "table-container"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { width: 200 }, {
                  default: _withCtx(({ row: key }) => [
                    _createTextVNode(_toDisplayString(_unref(upperFirst)(key)) + " ", 1),
                    (key === 'from')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(`(${isFromHost.value ? 'Host' : 'Renter'} info)`), 1)
                        ], 64))
                      : (key === 'to')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(`(${isFromHost.value ? 'Renter' : 'Host'} info)`), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, null, {
                  default: _withCtx(({ row: key }) => [
                    (key === 'trip')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(formatDateWithTime)(review.value.trip.start_date)) + " → " + _toDisplayString(_unref(formatDateWithTime)(review.value.trip.end_date)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (key === 'from' && fromUser.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(normalizeUserName)(fromUser.value)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (key === 'to' && toUser.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_unref(normalizeUserName)(toUser.value)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (key === 'vehicle')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_unref(normalizeCarName)(review.value.trip.car_profile)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (key === 'score')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createTextVNode(_toDisplayString(review.value.score), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: 150,
                  "class-name": "action-cell"
                }, {
                  default: _withCtx(({ row: key }) => [
                    (entities.includes(key))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          plain: "",
                          type: "primary",
                          size: "small",
                          icon: "el-icon-view",
                          onClick: ($event: any) => (handleShowPress(key))
                        }, {
                          default: _withCtx(() => _cache[0] || (_cache[0] = [
                            _createTextVNode(" Show details ")
                          ])),
                          _: 2,
                          __: [0]
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ], 64))
}
}

})